import useIsNexaDashboard from "@src/components/nexa/hooks/useIsNexaDashboard";


const useHideTabs = () => {
    const isNexaDashboard = useIsNexaDashboard();
    // add other conditions if needed

    return isNexaDashboard;
}

export default useHideTabs;
